<div class="user-panel"> 
    <span class="material-symbols-outlined profile-icon icon-filled">account_circle</span>
    <dx-context-menu
      *ngIf="menuMode === 'context'"
      [items]="menuItems"
      target=".user-button"
      showEvent="dxclick"
      width="150px"
      [position]="{ my: 'top center', at: 'bottom center' }"
      cssClass="user-menu"
      itemTemplate="item">
        <div *dxTemplate="let data of 'item'; let i = index" class="menu-item-link" (click)="onItemClick(data)">
            <span class="material-symbols-outlined icon-filled user-menu-icon">{{data.icon}}</span>
            <span class="dx-menu-item-text">{{data.text}}</span>
        </div>
    </dx-context-menu>
</div>